  <!--  顾客到店 -->
  <template>
    <div class="box">
        <div class="tab-box">
            <div class="store-box flex-start flex-y-center" v-if="regionPostId.includes(postId)">
                <div @click="openRegionPopup" class="region-name-box flex-row flex-between flex-y-center">
                    <div class="name-txt">{{checkedRegion.name}}</div>
                    <img class="store-arrow" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-right-arrow.png"
                        alt="">
                </div>
                <div v-if="checkedStore.id != -1" @click="openRegionStorePopup"
                    class="store-name-box flex-row flex-between flex-y-center">
                    <div class="name-txt">{{checkedStore.name}}</div>
                    <img class="store-arrow" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-right-arrow.png"
                        alt="">
                </div>
            </div>
            <div class="search">
                <form action="/">
                    <van-search class="search-button" v-model="name" @search="onSearch" @clear="selClear" placeholder="搜索姓名/手机"
                        left-icon="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-07/search.png">
                    </van-search>
                </form>
            </div>
            <div class="date-box  flex-row  flex-between">
                <div class="date">
                    <div class="arrow-box">
                        <div class="arrow-l" @click="handleCalendar('prev')"></div>
                    </div>
                    <div>{{year}}年{{month}}月</div>
                    <div class="arrow-box">
                        <div class="arrow-r" @click="handleCalendar('next')"></div>
                    </div>
                </div>
                <div class="change-box"
                    v-if="checkTypeTab==0&&(postId==1||postId==4||postId==11||postId=='1472787652026765367'||postId=='1472787652026765368')">
                    <van-dropdown-menu active-color="#37DBE0">
                        <van-dropdown-item v-model="employeeName" :options="employeeNameList"></van-dropdown-item>
                    </van-dropdown-menu>
                </div>
            </div>
        </div>
        <div class="table">
            <div class="table-tab  flex flex-x-center flex-between">
                <div :class="`tab-item ${tabIndex == 0?'active':''}`" @click="clickTab(0)">
                    本月未到诊({{bookingNumList.notArriveSum}})
                </div>
                <div :class="`tab-item item-text ${tabIndex == 1?'active':''}`" @click="clickTab(1)">
                    本月已到诊({{bookingNumList.arriveSum}})
                </div>
            </div>
            <div class="box-line"></div>
            <div class="table-list">
                <div class="tr-head bg-w">
                    <div class="th">姓名&手机</div>
                    <div class="th">所属主诊</div>
                    <div class="th">到诊次数</div>
                    <div class="th">上次到诊</div>
                </div>
                <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功">
                    <div class="data-list" v-if="bookingData.length > 0">
                        <!-- 下拉刷新 -->
                        <van-list v-model="loading" :finished="finished" :loading="loading" finished-text="没有更多了"
                            @load="getBookingData(year,month)" :offset="20" :immediate-check="false">
                            <div v-for="(item,index) in bookingData" :key="index">
                                <div class="tr line" @click="toDetail(item.custId,item.phone)">
                                    <div class="td">
                                        <div class="td-item">{{item.name}}</div>
                                        <div>{{item.phone}}</div>
                                    </div>
                                    <div class="td">
                                        <div>{{item.empName}}</div>
                                    </div>
                                    <div class="td">
                                        <div>{{item.comeNumber}}</div>
                                    </div>
                                    <div class="td">
                                        <div class="td-item">{{item.transDate}}</div>
                                    </div>
                                </div>

                            </div>
                        </van-list>
                    </div>
                    <div class="data-list" v-else style="margin:80px auto">
                        <van-empty
                            image="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-14/null.png"
                            description="暂无数据" />
                    </div>
                </van-pull-refresh>
                <!-- 区经区总 切换区域 -->
                <van-popup v-model="showRegionPopup" round position="bottom" closeable class="popup">
                    <picker title="选择区域" v-model="checkedRegion" :list="regionList" @change="onRegionChange"></picker>
                </van-popup>
                <!-- 区经区总 切换门店 -->
                <van-popup v-model="showRegionStorePopup" round position="bottom" closeable class="popup">
                    <picker title="选择门店" v-model="checkedStore" :list="regionStoreList" @change="onRegionStoreChange"></picker>
                </van-popup>
            </div>
        </div>
    </div>
</template>

  <script>
import request from "@/utils/request";
import { getCookie } from '@/utils'
import { Toast } from 'vant'
import Picker from '@/components/Picker';
import { mapState } from 'vuex'
import { getUserLogin, getRegionStoreList, saveRegionStore } from '@/api/home'

export default {
    name: "outpatientVisit",
    components: {
        Picker
    },
    inject: ['reload'],
    data() {
        return {
            tabIndex: 0, // tab栏下标
            bookingData: [// table数据
            ],
            employeeNameList: [
            ],
            employeeName: "0",
            activeName: "store", //tab
            tableData: [],
            tableHeader: [],
            year: "",
            month: "",
            name: "",
            bookingNumList: [],
            checkTypeTab: 0,
            postId: 0,
            loading: false,
            finished: false,
            refreshing: false,
            page: 1,
            total: 0,
            showRegionPopup: false,
            showRegionStorePopup: false,
            regionStoreList: [],//区域门店列表
            regionList: [],//区域列表
            checkedRegion: { id: -1, name: '' },//所选区域
            checkedStore: {  //所选门店
                name: '',
                id: -1,
            },
        };
    },
    computed: {
        ...mapState({
            regionPostId: (state) => {
                return state.user.permissions.regionPostId
            },// 区经区总id
        }),
    },
    mounted() {
        this.postId = getCookie('postId') || localStorage.getItem('postId');
        // 获取当前登陆人所记录的区域门店信息
        getUserLogin().then((res) => {
            if (this.regionPostId.includes(this.postId)) {
                this.checkedRegion.name = res.data.region?.storeName // 当前区域
                this.checkedRegion.id = res.data.region?.id
                if (res.data.store) {
                    this.checkedStore.name = res.data.store.storeName //当前门店
                    this.checkedStore.id = res.data.store.id
                    // 门店列表
                    let params = {
                        id: this.checkedRegion.id
                    }
                    getRegionStoreList(params).then((res) => {
                        this.regionStoreList = res.data
                    })
                }
                // 区域列表
                getRegionStoreList().then((res) => {
                    this.regionList = res.data
                })
                // 如果当前没有选择门店记录，则进入大区页面
                if (this.checkedStore.id == 0 || this.checkedStore.id == -1) {
                    this.$router.replace({
                        name: "outpatientVisitRegionPage"
                    });
                }
            }
            this.getemployeesList();
            this.initdateData();
            this.onRefresh()
            this.getbookingNumList();
        })
    },
    watch: {
        employeeName(value) {
            this.$nextTick(() => {
                this.page = 1;
                this.getBookingData(this.year, this.month);
                this.getbookingNumList();
            })
        }
    },
    methods: {
        // 初始化时间
        initdateData() {
            var date = new Date();
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            this.year = year
            this.month = month
        },
        //跳转顾客详情页
        toDetail(custId, phone) {
            this.$router.push({ name: "customerDetail", query: { custId: custId, phone: phone } });
        },
        // 获取到店列表的数据
        getBookingData(year, month) {
            // 自定义加载图标
            Toast.loading({
                message: '加载中...',
                forbidClick: true,
                // overlay: true,
                duration: 0, // 持续展示 toast
                loadingType: 'spinner',
            });
            this.loading = true
            let params = {
                keysword: this.searchStr,
                limit: 10,
                page: this.page,
                date: year + "-" + month,
                type: this.tabIndex,
                name: this.name,
                empNo: JSON.parse(localStorage.getItem('empNo')), // 当前登陆人自己的empid
                empId: this.employeeName,
            }
            if (this.regionPostId.includes(this.postId)) {
                params.id = this.checkedRegion.id
                params.storeId = this.checkedStore.id
            }
            request({
                url: "/index/briefing/visitPage",
                method: "get",
                params: params
            })
                .then((res) => {
                    this.bookingData = this.page == 1 ? res.data.list : this.bookingData.concat(res.data.list);
                    this.page += 1;
                    this.total = res.data.total;
                }).catch((error) => {
                    this.finished = true
                    Toast({ position: 'top', message: error ?? '' })
                }).finally(() => {
                    this.loading = false;
                    this.finished = false;
                    Toast.clear();

                    if (this.bookingData.length >= this.total) {
                        this.finished = true;
                    }
                });
        },
        // 切换月份
        handleCalendar(handle) {
            this.page = 1;
            const year = this.year;
            const month = this.month;
            this.bookingData = [];
            if (handle === "prev") {
                let newMonth = month - 1;
                let newYear = year;
                if (newMonth < 1) {
                    newYear = year - 1;
                    newMonth = 12;
                }
                this.getBookingData(newYear, newMonth);
                this.year = newYear
                this.month = newMonth
            } else {
                let newMonth = month + 1;
                let newYear = year;
                if (newMonth > 12) {
                    newYear = year + 1;
                    newMonth = 1;
                }
                this.getBookingData(newYear, newMonth);

                this.year = newYear
                this.month = newMonth
            }
            this.getbookingNumList();
        },
        // tab切换
        clickTab(tabIndex) {
            this.tabIndex = tabIndex
            this.onRefresh();
        },
        // 查询
        onSearch(e) {
            this.name = e
            this.getbookingNumList();
            this.onRefresh();
        },
        //清除搜索
        selClear() {
            this.name = "";
            this.onRefresh();
        },

        // 获取员工信息
        getemployeesList() {
            request({
                url: `/sys/params/selectByStoreTreasure`,
                method: "get",
                params: {
                    storeId: this.checkedStore.id,
                    id: this.checkedStore.id
                }
            })
                .then((res) => {
                    if (res.data.length > 0) {
                        this.employeeNameList = res.data.map(item => {
                            return { text: item.name, value: item.id }
                        })
                    }
                })
                .catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                }).finally(() => {
                })
        },
        // 获取我的预约数量
        getbookingNumList() {
            let params = {
                date: this.year + "-" + this.month,
                name: this.name,
                empNo: JSON.parse(localStorage.getItem('empNo')), // 当前登陆人自己的empid
                empId: this.employeeName,
                type: 1
            }
            if (this.regionPostId.includes(this.postId)) {
                params.id = this.checkedRegion.id
                params.storeId = this.checkedStore.id
            }
            request({
                url: `/index/briefing/quantity`,
                method: "get",
                params: params
            })
                .then((res) => {
                    this.bookingNumList = res.data
                })
                .catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                }).finally(() => {
                })
        },
        onRefresh() {
            this.page = 1
            // 清空列表数据
            this.finished = false;
            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.bookingData = [];
            this.refreshing = false;
            this.getBookingData(this.year, this.month);
        },
        // 筛选区域门店相关
        openRegionPopup() {
            this.showRegionPopup = true
        },
        onRegionChange(data) {
            this.checkedRegion = data
            this.showRegionPopup = false
            this.$nextTick(() => {
                // 提交所选区域记录 storeid 覆盖为0给后端判断是区域变更
                this.checkedStore.id = 0
                let params = {
                    id: this.checkedRegion.id,
                    storeId: this.checkedStore.id
                }
                saveRegionStore(params).then((res) => {
                    this.reload();
                })
            })
        },
        openRegionStorePopup() {
            this.showRegionStorePopup = true
        },
        onRegionStoreChange(data) {
            this.checkedStore = data
            this.showRegionStorePopup = false
            let params = {
                id: this.checkedRegion.id,
                storeId: this.checkedStore.id
            }
            saveRegionStore(params).then((res) => {
                this.reload();
            })
        },
    },
};
</script>

<style scoped lang="less">
.box {
    height: 100%;
}
.tab-box {
    width: 750px;
    // height: 314px;
    // background: #f5f6f7;
}
.data-list {
    height: 80vh;
    overflow-y: auto;
}

.title-tab-box {
    padding: 30px 30px 0 30px;
    :deep(.van-tabs__line) {
        display: none;
    }
    :deep(.van-tab) {
        width: 190px;
        padding: 0 !important;
        height: 70px !important;
        line-height: 70px !important;
        color: #a0acb5;
        font-size: 30px;
    }
    :deep(.van-tab.van-tab--active) {
        height: 70px !important;
        line-height: 70px;
        background: #2fd0d5 !important;
        border-radius: 35px !important;
        color: #fff !important;
    }
}
.date-box {
    margin-top: 15px;
    .date {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin: 0 30px;
        font-size: 30px;
        color: #35434c;
    }
    .arrow-l {
        width: 0;
        height: 0;
        border-top: 10px solid transparent;
        border-right: 10px solid #35434c;
        border-bottom: 10px solid transparent;
        margin-right: 20px;
    }
    .arrow-r {
        width: 0;
        height: 0;
        border-top: 10px solid transparent;
        border-left: 10px solid #35434c;
        border-bottom: 10px solid transparent;
        margin-left: 20px;
    }
}

.change-box {
    margin-right: 35px;
}
.table-tab {
    width: 100%;
    height: 100%;
    display: flex;
    margin: 39px 0 0 0;
}
.tab-item {
    width: 250px;
    height: 42px;
    font-size: 30px;
    font-weight: 400;
    color: #a0acb5;
    text-align: center;
    position: relative;
}
.item-text {
    margin-left: 102px;
}
.tab-item.active {
    color: #35434c;
    font-weight: bold;
}
.tab-item.active::after {
    position: absolute;
    bottom: -20px;
    content: "";
    width: 110px;
    height: 4px;
    background: #37dbe0;
    left: 50%;
    transform: translateX(-50%);
}
.box-line {
    width: 690px;
    height: 1px;
    background: #d7d7d7;
    margin: 20px 0 0 30px;
    opacity: 0.5;
}
.table-list {
    border: 0px solid darkgray;
    padding: 30px;
    height: 100%;
}
.tr-head {
    display: flex;
    width: 100%;
    justify-content: center;
    height: 80px;
    align-items: center;
}

.tr {
    display: flex;
    width: 100%;
    justify-content: center;
    height: 80px;
    align-items: center;
    border-bottom: 1px solid rgba(215, 215, 215, 0.5);
}
.td {
    width: 40%;
    justify-content: center;
    text-align: center;
    font-size: 28px;
    color: #35434c;
}
.td-item {
    margin-bottom: 17px;
}
.line {
    height: 133px;
}
.th {
    width: 40%;
    justify-content: center;
    background: #fafafe;
    color: #66757f;
    display: flex;
    height: 80px;
    align-items: center;
    font-size: 26px;
}
.mark {
    width: 98px;
    height: 30px;
    background: #d3f3f4;
    border-radius: 14px;
    margin: 0 auto;
    color: #37dbe0;
    font-size: 18px;
}
.van-pull-refresh {
    min-height: 100%;
}
.store-box {
    padding: 30px 30px;
    background-color: #fff;
    .store-arrow {
        width: 16px;
        height: 26px;
        margin-left: 8px;
        margin-top: 3px;
    }
    .region-name-box {
        min-width: 239px;
        height: 58px;
        background: #f5f5f5;
        border-radius: 35px;
        margin-right: 10px;
        padding: 10px 15px 11px 16px;
    }
    .store-name-box {
        min-width: 187px;
        height: 58px;
        background: #f5f5f5;
        border-radius: 35px;
        padding: 10px 15px 11px 16px;
    }
    .name-txt {
        color: #66757f;
        font-size: 26px;
    }
}
:deep(.van-dropdown-menu__bar) {
    box-shadow: none !important;
}

:deep(.search .van-search) {
    // background-color: #f5f6f7 !important;
    padding: 15px 30px !important;
}
:deep(.search .van-search .van-cell) {
    background-color: #f3f5f6 !important;
}
:deep(.search .van-icon) {
    font-size: 28px;
}
:deep(.search .van-search__content) {
    padding-left: 0 !important;
}
:deep(.van-field__left-icon) {
    color: #c8c9cc !important;
    padding: 8px 20px 0 20px !important;
    margin-right: 0 !important;
}

:deep(.van-list__finished-text) {
    height: 280px !important;
}
:deep(.van-tab--active) {
    font-weight: 400 !important;
}
:deep(.van-field__control) {
    font-size: 28px !important;
}

:deep(.van-dropdown-menu__title::after) {
    border-color: transparent transparent #35434c #35434c !important;
    border-top-width: 7px !important;
    border-right-width: 7px !important;
    border-bottom-width: 7px !important;
    border-left-width: 7px !important;
    border-top-style: solid !important;
    border-right-style: solid !important;
    border-bottom-style: solid !important;
    border-left-style: solid !important;
}
</style>


